import { render, staticRenderFns } from "./BandejaPacientes.vue?vue&type=template&id=551866e0"
import script from "./BandejaPacientes.vue?vue&type=script&lang=js"
export * from "./BandejaPacientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports